<template>
  <div class="footer">
    <div class="footer__contact bar">
      <div class="container">
        <div class="text-center text-lg-right">
          <p class="paragraph paragraph--fs15">
            <b>Pomoc techniczna: +48 505 199 139</b>
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 text-center text-lg-left">
          <p class="paragraph">
            (2018) Wszelkie prawa zastrzeżone przez <b>Geberit</b>
          </p>
        </div>
        <div class="col-lg-6 text-center text-lg-right">
          <p class="paragraph">
            Projekt i realizacja:
            <a href="http://mda.pl" title="MDA - Projektowanie stron www"
              >MDA.pl</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/FooterComponent.vue